import React from 'react'
import '../../Styles/AdditionalPages/Gallery.css'

export default function Gallery() {
  return (
    <div className='gallery'>
        Work under process
    </div>
  )
}
